import { useEffect } from "react";
import { CalendarCheck, ArrowUpRight } from "lucide-react";
import { PROFILE } from "../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Scheduler = () => {
  useEffect(() => {
    const id = "calendly-widget-script";
    if (!document.getElementById(id)) {
      const s = document.createElement("script");
      s.id = id;
      s.src = "https://assets.calendly.com/assets/external/widget.js";
      s.async = true;
      document.body.appendChild(s);
    }
    if (!document.getElementById("calendly-widget-css")) {
      const l = document.createElement("link");
      l.id = "calendly-widget-css";
      l.rel = "stylesheet";
      l.href = "https://assets.calendly.com/assets/external/widget.css";
      document.head.appendChild(l);
    }
  }, []);

  const calUrl = `${PROFILE.calendly}?hide_gdpr_banner=1&background_color=0a0a0b&text_color=f8f5ee&primary_color=d4af37`;

  return (
    <section data-testid="scheduler-section" id="schedule" className="relative py-28 lg:py-40 bg-charcoal-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28">
            <Reveal>
              <Eyebrow testid="scheduler-eyebrow">Discovery Call</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-6 leading-[1.05]">
                Grab a slot on <span className="italic text-gold-gradient">my calendar.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="text-cream/55 mt-6 text-base sm:text-lg leading-relaxed">
                A 30-minute, no-pitch conversation about your brand, your goals and whether we're
                the right fit. If I can't help, I'll point you to someone who can.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="mt-8 flex items-center gap-3 text-cream/70">
                <span className="h-10 w-10 rounded-full border border-gold/30 flex items-center justify-center text-gold">
                  <CalendarCheck size={18} />
                </span>
                <span className="text-sm">1-on-1 · 30 min · Video call</span>
              </div>
            </Reveal>
            <Reveal delay={0.4}>
              <a
                data-testid="scheduler-fallback-link"
                href={PROFILE.calendly}
                target="_blank"
                rel="noreferrer"
                className="mt-6 inline-flex items-center gap-1.5 text-gold text-sm hover:underline"
              >
                Open scheduler in a new tab <ArrowUpRight size={15} />
              </a>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <Reveal delay={0.2}>
              <div className="rounded-3xl border border-white/10 overflow-hidden bg-charcoal-900">
                <div
                  data-testid="calendly-inline"
                  className="calendly-inline-widget"
                  data-url={calUrl}
                  style={{ minWidth: "320px", height: "760px" }}
                />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
